<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon>  Type of Report
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-select v-model="form.rptType" :items="reportTypeList" :label="labels.rptType" item-text="label" item-value="value" />
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon>  Date Range
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <cal-picker v-model="form.tranDateFrom" :label="labels.tranDateFrom" :data-vv-as="labels.tranDateFrom" data-vv-name="form.tranDateFrom"
                          :error-messages="errors.collect('form.tranDateFrom')" v-validate="'required'" />
                      </v-flex>
                      <v-flex xs12 sm6>
                        <cal-picker v-model="form.tranDateTo" :label="labels.tranDateTo" :data-vv-as="labels.tranDateTo" data-vv-name="form.tranDateTo"
                          :error-messages="errors.collect('form.tranDateTo')" v-validate="'required'" />
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels v-model="panel3" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon>  Selection Criteria
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <v-text-field v-model="form.branch" :label="labels.branch" :error-messages="errors.collect('form.branch')" :data-vv-as="labels.branch" v-validate="'required'"
                          data-vv-name="form.branch" append-icon="mdi-magnify" @click:append="showBranchHelpList=true" @click="showBranchHelpList=true" readonly/>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field v-model="form.fund" :label="labels.fund" :error-messages="errors.collect('form.fund')" :data-vv-as="labels.fund" v-validate="'required'"
                          data-vv-name="form.fund" append-icon="mdi-magnify" @click:append="showFundHelpList=true" @click="showFundHelpList=true" readonly/>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-select v-model="form.dri" :items="driList" :label="labels.dri" item-text="label" item-value="value" :data-vv-as="labels.dri" v-validate="'required'"
                          data-vv-name="form.dri" />
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field v-model="form.dept" :label="labels.dept" :error-messages="errors.collect('form.dept')" :data-vv-as="labels.dept" v-validate="'required'"
                          data-vv-name="form.dept" append-icon="mdi-magnify" @click:append="showDeptHelpList=true" @click="showDeptHelpList=true" readonly/>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field v-model="form.polType" :label="labels.polType" :error-messages="errors.collect('form.polType')" :data-vv-as="labels.polType" v-validate="'required'"
                          data-vv-name="form.polType" append-icon="mdi-magnify" @click:append="showPolTypeHelpList=true" @click="showPolTypeHelpList=true" readonly/>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field v-model="form.busCls" :label="labels.busCls" :error-messages="errors.collect('form.busCls')" :data-vv-as="labels.busCls" v-validate="'required'"
                          data-vv-name="form.busCls" append-icon="mdi-magnify" @click:append="showBusClsHelpList=true" @click="showBusClsHelpList=true" readonly/>
                      </v-flex>
                      <v-layout row wrap>
                        <v-flex xs12 md6>
                          <!-- <v-text-field v-model="form.uwYearFrm" :label="labels.uwYearFrm" :error-messages="errors.collect('uwYearFrm')" :data-vv-as="labels.uwYearFrm" type="number"></v-text-field> -->
                          <v-select single v-model="form.uwYearFrm" :label="labels.uwYearFrm" :data-vv-as="labels.uwYearFrm" data-vv-name="uwYearFrm" :items="years"></v-select>
                        </v-flex>
                        <v-flex xs12 md6>
                          <!-- <v-text-field v-model="form.uwYearTo" :label="labels.uwYearTo" :error-messages="errors.collect('uwYearTo')" :data-vv-as="labels.uwYearTo" type="number"></v-text-field> -->
                          <v-select single v-model="form.uwYearTo" :label="labels.uwYearTo" :data-vv-as="labels.uwYearTo" data-vv-name="uwYearTo" :items="years" :error-messages="errors.collect('uwYearTo')" v-validate="doValidateToUWYear"></v-select>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md6>
                          <!-- <v-text-field v-model="form.lossYearFrom" :label="labels.lossYearFrom" :error-messages="errors.collect('lossYearFrom')" :data-vv-as="labels.lossYearFrom" type="number"></v-text-field> -->
                          <v-select single v-model="form.lossYearFrom" :label="labels.lossYearFrom" :data-vv-as="labels.lossYearFrom" data-vv-name="lossYearFrom" :items="years"></v-select>
                        </v-flex>
                        <v-flex xs12 md6>
                          <!-- <v-text-field v-model="form.lossYearTo" :label="labels.lossYearTo" :error-messages="errors.collect('lossYearTo')" :data-vv-as="labels.lossYearTo" type="number"></v-text-field> -->
                          <v-select single v-model="form.lossYearTo" :label="labels.lossYearTo" :data-vv-as="labels.lossYearTo" data-vv-name="lossYearTo" :items="years" :error-messages="errors.collect('lossYearTo')" v-validate="doValidateToLossYear"></v-select>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field v-model="form.grossClmRes" :label="labels.grossClmRes" :error-messages="errors.collect('grossClmRes')" :data-vv-as="labels.grossClmRes" type="number"></v-text-field>
                        </v-flex>
                      </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels v-model="panel4" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon>  Sort Order
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <sort-order-table-basic :columns="columns" :headers="headers" :sortedListContainer="sortedListContainer" />
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
            <v-checkbox :label="labels.pbPrtParam" v-model="form.pbPrtParam" :error-messages="errors.collect('pbPrtParam')"
              data-vv-name="pbPrtParam" :data-vv-as="labels.pbPrtParam" />
        </v-flex>
        <v-flex xs12>
          <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{labels.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
            <v-btn flat v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{format.label}}</span>
              <v-icon :color="format.color">{{format.icon}}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="showDeptHelpList" width="900px" persistent>
      <multi-dept-help-list :dept="form.dept" @close="doClose" @doAssign="doAssignDept($event)" />
    </v-dialog>
    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="form.branch" @close="doClose" @doAssign="doAssignBranch($event)" />
    </v-dialog>
    <v-dialog v-model="showBusClsHelpList" width="900px" persistent>
      <multi-bus-cls-help-list :busCls="form.busCls" @close="doClose" @doAssign="doAssignBusCls($event)" />
    </v-dialog>
    <v-dialog v-model="showFundHelpList" width="900px" persistent>
      <multi-fund-help-list :fnd="form.fund" @close="doClose" @doAssign="doAssignFund($event)"/>
    </v-dialog>
    <v-dialog v-model="showPolTypeHelpList" width="900px" persistent>
      <multi-pol-type-help-list :pt="form.polType" @close="doClose" @doAssign="doAssignPolType($event)" />
    </v-dialog>
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList.vue'
import MultiBusClsHelpList from '@/components/core/common/dialog/MultiBusClsHelpList.vue'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import MultiDeptHelpList from '@/components/core/common/dialog/MultiDeptHelpList.vue'
import MultiFundHelpList from '@/components/core/common/dialog/MultiFundHelpList.vue'
import SortOrderTableBasic from '@/components/reusable/SortOrderTableBasic'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
export default {
  mixins: [
    MessageMixin
  ],
  components: {
    MultiBranchHelpList,
    MultiBusClsHelpList,
    MultiPolTypeHelpList,
    MultiDeptHelpList,
    MultiFundHelpList,
    SortOrderTableBasic
  },
  data() {
    return {
      menu: {},
      showDeptHelpList: false,
      showBranchHelpList: false,
      showBusClsHelpList: false,
      showFundHelpList: false,
      showPolTypeHelpList: false,
      submitting: false,
      form: {
        rptType: 'A',
        tranDateFrom: new Date(),
        tranDateTo: new Date(),
        branch: 'All',
        fund: 'All',
        dri: 'D',
        dept: 'All',
        polType: 'All',
        busCls: 'All',
        uwYearFrm: 0,
        uwYearTo: 0,
        lossYearFrom: 0,
        lossYearTo: 0,
        grossClmRes: 0,
        sortOrder: 'L',
        pbPrtParam: true,
        format: 'PDF',
        isUW: false
      },
      labels: {
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        branch: 'Branch',
        fund: 'Fund',
        dri: 'Direct / RI',
        dept: 'Department',
        polType: 'Policy Type',
        busCls: 'Business Class',
        uwYearFrm: 'Underwriting Year From',
        uwYearTo: 'Underwriting Year To',
        lossYearFrom: 'Loss Year From',
        lossYearTo: 'Loss year To',
        grossClmRes: 'Gross Claims Reserve',
        sortOrder: 'Sort Order',
        rptType: 'Report Type',
        pbPrtParam: 'Print Runtime Parameters',
        export: 'EXPORT TO'
      },
      driList: [
        { label: 'D - Direct', value: 'D' },
        { label: 'R - Reinsurance', value: 'R' },
        { label: 'B - Both', value: 'B' }
      ],
      reportTypeList: [
        { label: 'By Accounting Period', value: 'A' },
        { label: 'By Loss Date', value: 'L' }
      ],
      columns: [
        { label: 'Agent', value: 'agent' },
        { label: 'Branch', value: 'branch' },
        { label: 'Claim Year', value: 'clmYr' },
        { label: 'Class', value: 'busCls' },
        { label: 'Class Group', value: 'busClsGrp' },
        { label: 'Department', value: 'dept' },
        { label: 'Direct/RI', value: 'dri' },
        { label: 'Fund', value: 'fund' },
        { label: 'Policy Type', value: 'polType' },
        { label: 'UW Year', value: 'uwYr' }
      ],
      headers: [
        { label: 'Sub Total', value: 'subTotal' },
        { label: 'Page Break', value: 'pageBreak' }
      ],
      sortedListContainer: {
        sortedList: [],
        cDescList: []
      },
      supportedFormat: [],
      panel1: [0],
      panel2: [],
      panel3: [],
      panel4: [0],
      panel5: [],
      yearsList: []
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    years() {
      const tempYearList = []
      const year = new Date().getFullYear()
      tempYearList.push(0)
      for (var i = 1999; i <= year; i++) {
        tempYearList.push(i)
      }
      return tempYearList
    },
    doValidateToLossYear() {
      if (this.form.lossYearFrom !== 0) {
        return '|valMaxLossYear:' + this.form.lossYearFrom
      } else {
        return ''
      }
    },
    doValidateToUWYear() {
      if (this.form.uwYearFrm !== 0) {
        return '|valMaxUWYear:' + this.form.uwYearFrm
      } else {
        return ''
      }
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      try {
        if (this.$store.state.reports.claimReports.init !== 1) {
          await this.$store.dispatch('claimReportsInit')
        }
        const apiURI = this.$store.state.reports.claimReports.menu.clmGrossRes
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      if (this.sortedListContainer.sortedList.length === 0) {
        this.$toast.error('Please select sort columns.')
        return
      }
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        this.form.sort = this.sortedListContainer.sortedList
        this.form.cDesc = this.sortedListContainer.cDescList
        try {
          this.submitting = true
          this.form.sort = this.sortedListContainer.sortedList
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doClose() {
      this.showBranchHelpList = false
      this.showBusClsHelpList = false
      this.showFundHelpList = false
      this.showPolTypeHelpList = false
      this.showDeptHelpList = false
    },
    async doAssignBranch(obj) {
      this.form.branch = []
      this.form.branch = obj.finalSelectedItems.toString()
    },
    async doAssignBusCls(obj) {
      this.form.busCls = []
      this.form.busCls = obj.finalSelectedItems.toString()
    },
    async doAssignPolType(obj) {
      this.form.polType = []
      this.form.polType = obj.finalSelectedItems.toString()
    },
    async doAssignDept(Obj) {
      this.form.dept = []
      this.form.dept = Obj.finalSelectedItems.toString()
    },
    async doAssignFund(Obj) {
      this.form.fund = []
      this.form.fund = Obj.finalSelectedItems.toString()
    }
  },
  created() {
    this.$validator.extend('valMaxLossYear', {
      getMessage(field, args) {
        return 'Loss Year To cannot be earlier than Loss Year From'
      },
      validate(value, args) {
        let dateSelected = args[0]
        if (value < dateSelected) {
          return false
        } else return true
      }
    })
    this.$validator.extend('valMaxUWYear', {
      getMessage(field, args) {
        return 'Underwriting Year To cannot be earlier than Underwriting Year From'
      },
      validate(value, args) {
        let dateSelected = args[0]
        if (value < dateSelected) {
          return false
        } else return true
      }
    })
  }
}
</script>
